/** Fired after an install, update, enable, disable or uninstall succeeds. */
export const EXTENSION_INSTALLATIONS_CHANGED_EVENT =
  "sylviq:extension-installations-changed";

export function notifyExtensionInstallationsChanged(): void {
  window.dispatchEvent(new Event(EXTENSION_INSTALLATIONS_CHANGED_EVENT));
}
